import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { WhyItWorks } from './components/WhyItWorks';
import { Testimonials } from './components/Testimonials';
import { Benefits } from './components/Benefits';
import { FAQ } from './components/FAQ';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-navy-50 to-sage-50" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex flex-col w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <Solution data-id="element-5" />
        <WhyItWorks data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Benefits data-id="element-8" />
        <FAQ data-id="element-9" />
        <Pricing data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}